// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2Pgo_","text":"SelectPayment_text__VLf8q","title":"SelectPayment_title__3ni5n","btn":"SelectPayment_btn__41869"};